import React from "react";

const PrivacyPolicy = () => {
    return (
        <div className="p-6 bg-gray-100 min-h-screen">
            <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-8">
                <h1 className="text-2xl font-bold text-gray-800 mb-4">Privacy Policy</h1>
                <p className="text-sm text-gray-600 mb-6">Effective Date: 01 Jan 2025</p>
                <p className="text-gray-700 mb-6">
                    Your privacy is important to us. This Privacy Policy outlines how we collect, use, 
                    and protect your information when you use any of the apps launched by 
                    <span className="font-semibold"> CodeBasera Technologies</span> ("the Apps"). By using any of the Apps, 
                    you agree to the terms of this Privacy Policy.
                </p>

                <h2 className="text-xl font-semibold text-gray-800 mb-4">1. Information We Collect</h2>
                <h3 className="text-lg font-medium text-gray-800 mb-2">1.1 Personal Information</h3>
                <p className="text-gray-700 mb-4">We collect the following types of information:</p>
                <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
                    <li>Name</li>
                    <li>Contact information (e.g., phone number, email address)</li>
                    <li>Family details (e.g., family members, relations)</li>
                    <li>Address</li>
                    <li>Family events</li>
                    <li>Matrimony profiles</li>
                    <li>Education, Business information</li>
                </ul>

                <h3 className="text-lg font-medium text-gray-800 mb-2">1.2 Community-Specific Information</h3>
                <p className="text-gray-700 mb-6">Caste and community details</p>

                <h3 className="text-lg font-medium text-gray-800 mb-2">1.3 Technical Information</h3>
                <p className="text-gray-700 mb-4">We also collect technical information such as:</p>
                <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
                    <li>Device information (e.g., model, operating system)</li>
                    <li>Usage data (e.g., login times, features accessed)</li>
                    <li>IP address</li>
                </ul>

                <h2 className="text-xl font-semibold text-gray-800 mb-4">2. How We Use Your Information</h2>
                <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
                    <li>Connecting families and relatives within the society.</li>
                    <li>Facilitating matrimonial and community-building activities.</li>
                    <li>Sending notifications and updates about community and family events.</li>
                    <li>Improving the app and its features.</li>
                </ul>

                <h2 className="text-xl font-semibold text-gray-800 mb-4">3. Sharing of Information</h2>
                <p className="text-gray-700 mb-4">
                    We do not sell or rent your information. However, we may share your information:
                </p>
                <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
                    <li>With verified members of the app for the purpose of building family and social connections.</li>
                    <li>With legal authorities if required by law.</li>
                </ul>

                <h2 className="text-xl font-semibold text-gray-800 mb-4">4. Data Security</h2>
                <p className="text-gray-700 mb-6">
                    We use industry-standard measures to protect your data from unauthorized access, loss, or misuse. 
                    However, no system can guarantee complete security.
                </p>

                <h2 className="text-xl font-semibold text-gray-800 mb-4">5. Your Rights</h2>
                <p className="text-gray-700 mb-4">You have the right to:</p>
                <ul className="list-disc list-inside text-gray-700 mb-6 space-y-1">
                    <li>Access the data we hold about you.</li>
                    <li>Request corrections to your information.</li>
                    <li>Delete your account and associated data which does not affect functionality of these apps.</li>
                </ul>

                <h2 className="text-xl font-semibold text-gray-800 mb-4">6. Children’s Privacy</h2>
                <p className="text-gray-700 mb-6">
                    The app is intended for individuals above 18 years. Children below this age must use the app 
                    under parental guidance.
                </p>

                <h2 className="text-xl font-semibold text-gray-800 mb-4">7. Changes to This Policy</h2>
                <p className="text-gray-700 mb-6">
                    We may update this Privacy Policy from time to time. You will be notified of any significant 
                    changes through the app.
                </p>

                <h2 className="text-xl font-semibold text-gray-800 mb-4">8. Contact Us</h2>
                <p className="text-gray-700 mb-2">
                    If you have any questions or concerns about this Privacy Policy, contact us at:
                </p>
                <p className="text-gray-700 font-medium">Email: contact@codebasera.com</p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
